import formatMoney from './formatMoney.js'
export type * from './types.js'
export default formatMoney
